import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RamiFormComponent } from './dialogs/form/form.component';
import { RamiComponent } from './rami.component';


const routes: Routes = [
  {
    path: '', component: RamiComponent
  },
  {
    path: 'inserisci', component: RamiFormComponent,
    data: { title: 'Inserimento Rami' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RamiRoutingModule { }
